import React from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { useCarousel } from "@/components/ui";

export const CarouselArrows = () => {
  const { scrollNext, canScrollNext, scrollPrev, canScrollPrev } =
    useCarousel();
  return (
    <>
      {/* next */}
      <div
        className={cn(
          "absolute top-0 right-0 z-2 h-full w-17 bg-gradient-to-r from-white/0 via-white via-50% to-white opacity-100",
          !canScrollNext && "z-[-1] opacity-0",
        )}
      >
        <button
          disabled={!canScrollNext}
          onClick={scrollNext}
          className={cn(
            "absolute right-0 flex h-full w-8 items-center justify-center bg-white disabled:opacity-0",
          )}
        >
          <ArrowRight className="h-5 w-5" />
        </button>
      </div>
      {/* prev */}
      <div
        className={cn(
          "absolute top-0 left-0 z-2 h-full w-17 bg-gradient-to-l from-white/0 via-white via-50% to-white opacity-100 transition-opacity duration-300",
          !canScrollPrev && "z-[-1] opacity-0",
        )}
      >
        <button
          onClick={scrollPrev}
          className={cn(
            "absolute left-0 flex h-full w-8 items-center justify-center bg-white disabled:opacity-0",
          )}
        >
          <ArrowLeft className="h-5 w-5" />
        </button>
      </div>
    </>
  );
};
